<template>
  <div>
    <DragAndDropFileInput
      accept=".csv"
      :maxFileSize="5 * 1024 * 1024"
      :file="file"
      title="Drag and drop your CSV file here"
      @file-selected="$emit('file-selected', $event)"
    />
    <Alert v-if="columns.length > 0" class="mt-6" variant="info" message="Expected Columns">
      <v-progress-circular v-if="loading" :size="24" color="brandPrimary" indeterminate />
      <div v-else class="columns-grid">
        <ul v-for="(chunk, index) in columnChunks" :key="index">
          <li v-for="column in chunk" :key="column.value">
            <Typography variant="body-2" class="black--text">{{ column.label }}</Typography>
          </li>
        </ul>
      </div>
    </Alert>
    <div class="d-flex align-center pt-6">
      <Typography variant="subtitle-1">Do you need a template?</Typography>
      <Button
        :disabled="loading"
        :loading="downloadingTemplate"
        text
        @click="handleDownloadTemplate"
      >
        Download Template
      </Button>
    </div>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import Alert from "@/components/generic/Alert.vue";
import DragAndDropFileInput from "@/components/DragAndDropFileInput.vue";
import csvGenerationMixin from "@/mixins/csvGenerationMixin";

export default {
  name: "CSVDragAndDrop",
  components: {
    Typography,
    Button,
    Alert,
    DragAndDropFileInput,
  },
  mixins: [csvGenerationMixin],
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    file: {
      type: File,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    templateFileName: {
      type: String,
      default: "template.csv",
    },
    downloadTemplateFn: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      downloadingTemplate: false,
    };
  },
  computed: {
    columnChunks() {
      const chunks = [];
      for (let i = 0; i < this.columns.length; i += 4) {
        chunks.push(this.columns.slice(i, i + 4));
      }
      return chunks;
    },
  },
  methods: {
    async handleDownloadTemplate() {
      this.downloadingTemplate = true;
      try {
        if (this.downloadTemplateFn) {
          await this.downloadTemplateFn();
        } else {
          this.downloadCSVTemplate(this.columns, this.templateFileName);
        }
      } catch (error) {
        console.error("Error downloading template", error);
        this.$store.dispatch("showError", {
          message: "We ran into an issue while downloading the template",
        });
      } finally {
        this.downloadingTemplate = false;
      }
    },
  },
};
</script>

<style scoped>
.columns-grid {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.columns-grid ul {
  margin: 0;
  padding-left: 20px;
  color: black;
}
</style>
